module.exports = __webpack_public_path__ + "static/media/koronowska.2eaf6422.svg";